// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Div, Button } from "@components/Generics.react";
import { Radio } from "semantic-ui-react";
import ImageUploader from "@components/ImageUploader.react";

export default function RadioImgField(props) {
    const { noRadio = false, value, setValue, height } = props;
    const [inputValue, setInputValue] = useState(value.image);
    const [checkValue, setCheckValue] = useState(value.correct);
    const [imgEditorOpen, setImgEditorOpen] = useState(false);
    const { t } = useTranslation("common");

    // Debouncing the user input
    //==================================
    useEffect(() => {
        setInputValue(value.image);
        setCheckValue(value.correct);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        setValue({ image: inputValue, correct: checkValue });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue, checkValue]);

    // ========================= Render Function =================================
    return (
        <Div minHt={height} ht={height} ivory basepad snug>
            <Div smoke ht={"calc(100% - 60px)"} fluid flex spaceBetween>
                {!noRadio && (
                    <Radio
                        label={
                            checkValue === "checked"
                                ? t("builder.deck.correct")
                                : t("builder.deck.incorrect")
                        }
                        name="radioGroup"
                        checked={checkValue === "checked"}
                        onChange={(e) =>
                            setCheckValue(
                                checkValue === "correct" ? "" : "checked"
                            )
                        }
                    />
                )}
                <Div wd={`calc(100% - ${noRadio ? 0 : 100}px)`}>
                    <Div rimmed>
                        <Button
                            content={`Change Image`}
                            secondary
                            onClick={() => setImgEditorOpen(true)}
                        />
                        <ImageUploader
                            modalOpen={imgEditorOpen}
                            handleModalClose={() => setImgEditorOpen(false)}
                            handleModalSave={(image) => {
                                setInputValue(image);
                                setImgEditorOpen(false);
                            }}
                            value={inputValue}
                            aspectRatio={0.5625}
                            mWidth={512}
                        />
                    </Div>
                </Div>
            </Div>
        </Div>
    );
}
